import Vue from "vue";
import axios from "axios"; // Lecture 346
import { MODEL_USER_PHONE_FIELD } from "../constants/model-by-types";
import { BUILDER_TYPE, BUILDER_USER_TYPE } from "../constants/custom-define-type";

Vue.mixin({
    methods: {
        // Get max value of created_date, last_login, last_updated
        getLastAccessTime(user) {
            let lastAccess = null;
            const listAccessModels = ["created_date", "last_login", "last_updated_date", "last_activity"];
            for (const accessModel of listAccessModels) {
                if (user[accessModel]) {
                    if (!lastAccess) {
                        lastAccess = user[accessModel]
                    } else if (user[accessModel] > lastAccess) {
                        lastAccess = user[accessModel]
                    }
                }
            }
            return lastAccess
        },
        getAdminNameFromId(id) {
            if (!this.$store.getters.adminList) {
                return null;
            }
            const admin = this.$store.getters.adminList.find(item => item.id === id);
            if (!admin) {
                return null;
            }
            return `${admin.first_name} ${admin.last_name}`
        },
        generatePlaceholderEmail(userInfo) {
            let result;
            if (userInfo.phone) {
                // For leaf cleanup we are not asking for an email address so making a fake one out of the phone number
                result = `${userInfo.phone.replace(
                    /\s+/,
                    ""
                )}@${this.$store.getters.agencyHumanName.toLowerCase()}.com`;
            } else {
                const userName =
                    userInfo.first_name +
                    "+" +
                    userInfo.last_name +
                    "+" +
                    new Date().toISOString();
                // If there is no email, no phone => user is created by first name, last name
                result = `${userName}@${this.$store.getters.agencyHumanName.toLowerCase()}.com`;
            }
            return result.replace(
                /\s+|\:|\!|\+|\;/g,
                ""
            );
        },
        getPlaceholderPrefix(userInfo) {
            const userName =
                userInfo.first_name +
                "+" +
                userInfo.last_name + "+20";
            return userName.replace(
                /\s+|\:|\!|\+|\;/g,
                ""
            ).toLowerCase();
        },
        getPlaceholderSuffix() {
            let result = `@${this.$store.getters.agencyHumanName.toLowerCase()}.com`;
            return result.replace(
                /\s+|\:|\!|\+|\;/g,
                ""
            );
        },
        async getPublicVideoRecordingLink(userId) {
            if (!userId) {
                return "";
            }
            if (!this.$store.getters.hasCandidateIntroVideo) {
                return "";
            }
            const hashId = await this.getHashId(Number(userId) + 10);
            return `${this.rootUrl}/candidate-video-recording/${userId}/${hashId}`
        },
        convertPhoneInfo(userObject) {
            for (const phoneField of MODEL_USER_PHONE_FIELD) {
                if (userObject[phoneField]) {
                    userObject[phoneField] = this.getDisplayPhone(userObject[phoneField]);
                }
            }
        },
        getUserType(user) {
            let userType = "";
            if (user.is_employer) {
                userType = "Client";
            } else if (user.is_agent) {
                userType = "Admin";
            } else if (user.is_candidate) {
                userType = "Candidate";
            }
            return userType;
        },
        getUserProfileBuilder(user, listBuilder = null) {
            if (listBuilder == null) {
                listBuilder = this.$store.getters.profileBuilderList;
            }
            let applicationFormId = user.application_form;
            if (typeof applicationFormId !== "number") {
                applicationFormId = user.application_form_id;
            }
            // Find corresponding profile builder
            let profileBuilder = listBuilder.find(
                (builder) =>
                    builder.application_builder_id === applicationFormId &&
                    builder.type === BUILDER_TYPE.PROFILE &&
                    builder.user_type === BUILDER_USER_TYPE.CLIENT
            );
            if (profileBuilder) {
                return profileBuilder;
            }
            // If There is no builder for profile, use builder for application instead
            profileBuilder = listBuilder.find(
                (builder) => builder.id === applicationFormId
            );
            if (profileBuilder) {
                return profileBuilder;
            }
            // For old data, which is not set applicaiton_form, find one profile builder
            profileBuilder = listBuilder.find(
                (builder) =>
                    builder.type === BUILDER_TYPE.PROFILE &&
                    builder.user_type === BUILDER_USER_TYPE.CLIENT
            );
            if (profileBuilder) {
                return profileBuilder;
            }
            // For old data, which is not set applicaiton_form, no profile builder => use application builder
            profileBuilder = listBuilder.find(
                (builder) =>
                    builder.type === BUILDER_TYPE.APPLICATION &&
                    builder.user_type === BUILDER_USER_TYPE.CLIENT
            );
            return profileBuilder;
        },
        async getUserById(id) {
            const res = await axios.get(`/api/people/${id}/`);
            if (res && res.data) {
                return res.data;
            }
            return null;
        }
    }
});


// WEBPACK FOOTER //
// ./src/mixins/user-info-handling.js